import ErrorMessage from "components/ErrorMessage";
import OButton from "components/reusable/OButton";
import OInputField from "components/reusable/OInputField";
import useToastContext from "hooks/useToastContext";
import { startCase } from "lodash";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import OtpInput from "react18-input-otp";
import { apiGet, apiPost } from "utils/apiFetch";
import apiPath from "utils/pathObj";

import { faChevronDown, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";

const CashOut = ({ setShowCashOutModal }) => {
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({ mode: "onChange", shouldFocusError: true, defaultValues: {} });
  const notification = useToastContext();
  const [cashInLoading, setCashInLoading] = useState(false);
  const [cashPreview, setCashPreview] = useState(false);
  const [cashPreviewOtp, setCashPreviewOtp] = useState(false);
  const [cashPreviewData, setCashPreviewData] = useState({});
  var isTimer = Number(localStorage.getItem("seconds")) > 0 ? Number(localStorage.getItem("seconds")) : 60;
  const [seconds, setSeconds] = useState(isTimer);
  const [minutes, setMinutes] = useState("00");
  const [timerActive, setTimerActive] = useState(true);
  const [otp, setOtp] = useState(null);
  const [otpError, setOtpError] = useState("");

  const [selectedWallet, setSelectedWallet] = useState(null);
  const [availableWallets, setAvailableWallets] = useState([]);
  const [loadingWallets, setLoadingWallets] = useState(false);
  const abortController = new AbortController();

  const handleOTPChange = (enteredOtp) => {
    setOtp(enteredOtp);
  };

  const handleSubmitForm = async (data) => {
    if (!otp) {
      setOtpError("Please enter OTP.");
      return;
    } else if (otp.length < 4) {
      setOtpError("Please enter OTP.");
      return;
    } else {
      setOtpError("");
    }
    try {
      setCashInLoading(true);
      const sendData = {};
      let input = data?.username;
      if (input === data?.username) {
        sendData.username = input;
        sendData.walletId = selectedWallet._id;
        sendData.amount = Number(data.amount);
        sendData.type = "username";
        sendData.otp = otp;
      }
      const path = `${apiPath.AddCashOut}?type=username`;
      const res = await apiPost(path, sendData);
      if (res.data.success === true) {
        setShowCashOutModal(false);
        notification.success(res.data.message);
      } else {
        notification.error(res?.data?.message);
      }
    } catch (err) {
      console.log("err:", err);
    } finally {
      setCashInLoading(false);
    }
  };

  const handleSubmitPreview = async (data) => {
    try {
      setCashInLoading(true);

      const sendData = {};
      let input = data?.username;
      if (input === data?.username) {
        sendData.username = input;
        sendData.walletId = selectedWallet._id;
        sendData.amount = Number(data.amount);
        sendData.type = "username";
      }
      const path = `${apiPath.cashOutPreview}?type=username`;
      const res = await apiPost(path, sendData);
      if (res?.data?.success === true) {
        setCashPreviewData(res?.data?.results);
        setCashPreview(true);
        notification.success(res.data.message);
      } else {
        notification.error(res?.data?.message);
      }
    } catch (err) {
      console.log("err:", err);
    } finally {
      setCashInLoading(false);
    }
  };

  const handleSubmitOtp = async (data) => {
    try {
      setCashInLoading(true);
      const sendData = {};
      let input = data?.username;
      if (input === data?.username) {
        sendData.username = input;
        sendData.walletId = selectedWallet._id;
        sendData.amount = Number(data.amount);
        sendData.type = "username";
      }
      const path = `${apiPath.cashOutSendOtp}?type=username`;
      const res = await apiPost(path, sendData);
      if (res?.data?.success === true) {
        setCashPreviewOtp(true);
        notification.success(res.data.message);
        localStorage.setItem("seconds", 60);
      } else {
        setShowCashOutModal(false);
        notification.error(res?.data?.message);
      }
    } catch (err) {
      console.log("err:", err);
    } finally {
      setCashInLoading(false);
    }
  };
  const handleResendOTP = async (data) => {
    try {
      if (minutes === 0 && seconds === 0) {
        let sendData = {};
        let input = data?.username;
        if (input === data?.username) {
          sendData.username = input;
          sendData.walletId = selectedWallet._id;
          sendData.amount = Number(data.amount);
          sendData.type = "username";
        }
        sendData.resend = true;
        const res = await apiPost(`${apiPath.cashOutSendOtp}?type=username`, sendData);
        if (res.data.success === true) {
          notification.success(res.data.message);
          setSeconds(60);
          setMinutes(0);
        } else {
          notification.error(res.data.message);
        }
      }
    } catch (err) {
      console.log("err:", err);
    }
  };

  const fetchUserWallets = async (username) => {
    try {
      abortController.abort();
      setLoadingWallets(true);
      const res = await apiGet(apiPath.getUserWallets + "?username=" + username, abortController.signal);
      setLoadingWallets(false);
      if (res.data.success) {
        setAvailableWallets(res.data.results);
        if (res.data.results.length === 1) {
          setSelectedWallet(res.data.results[0]);
        }
      } else {
        setSelectedWallet(null);
        setAvailableWallets([]);
      }
    } catch (err) {
      setLoadingWallets(false);
      setSelectedWallet(null);
      setAvailableWallets([]);
      console.log("err:", err);
    }
  };

  let timerRef;
  useEffect(() => {
    if (cashPreviewOtp) {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      timerRef = setInterval(() => {
        if (minutes >= 0) {
          if (seconds === 0) {
            if (minutes > 0) {
              setSeconds(60);
              setMinutes((prev) => prev - 1);
            } else {
              setSeconds(0);
            }
          } else {
            setSeconds((prev) => prev - 1);
          }
        } else {
          clearInterval(timerRef);
          setTimerActive(false);
        }
      }, 1000);
      return () => clearInterval(timerRef);
    }
  });

  localStorage.setItem("seconds", seconds);

  const clearTime = () => {
    setSeconds(0);
    localStorage.setItem("seconds", 0);
    setShowCashOutModal(false);
  };

  useEffect(() => {
    if (cashPreviewOtp) {
      window.onbeforeunload = function (event) {
        clearTime();
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cashPreviewOtp]);

  const handleAmount = (e) => {
    var value = e.target.value;
    const pattern = /^\d{0,5}(\.\d{0,2})?$/;
    if (e.target.value === "") {
      e.target.value = e.target.value.slice(e.target.value?.length - 1, -1);
    }
    const isValid = pattern.test(value);
    if (!isValid) {
      value = value.slice(0, -1);
    }
    setValue("amount", value);
  };
  var pressedKeys = [];

  return (
    <>
      <div id="add-agent" className="fixed  pt-16 z-40 h-screen px-6 pb-4 overflow-y-auto bg-white sm:w-96 w-80 right-0 top-0 " aria-labelledby="drawer-label">
        <div>
          <button
            onClick={() => setShowCashOutModal(false)}
            title="Close"
            type="button"
            data-drawer-hide="drawer-example"
            aria-controls="drawer-example"
            className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 absolute top-2.5 right-2.5 inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white"
          >
            <img src="./images/close-circle.png" alt="close" />

            <span className="sr-only">{t("CLOSE_MENU")}</span>
          </button>
        </div>
        <h3 className="font-medium text-[18px] mb-4 ">{t("CASH_OUT_TOP_UP")}</h3>
        <div className="flex my-5 gap-4">
          <div className="relative w-full ">
            <OInputField
              name="username"
              inputLabel={
                <>
                  {t("O_USERNAME")}
                  <span className="text-red-500">*</span>
                </>
              }
              errors={errors}
              type="text"
              onKeyDown={(e) => {
                if ([" "].includes(e.key)) {
                  e.preventDefault();
                }
              }}
              onChange={(e) => {
                fetchUserWallets(e.target.value);
              }}
              register={register("username", {
                required: t("PLEASE_ENTER_USERNAME"),
                minLength: {
                  value: 1,
                  message: t("PLEASE_ENTER_USERNAME"),
                },
              })}
            />
          </div>
        </div>

        <Menu as="div" className="relative inline-block w-full flex justify-center">
          <MenuButton className="w-full rounded-md bg-gray-200 px-3 py-2 inset-ring-1 inset-ring-white/5 hover:bg-gray-300">
            {selectedWallet ? (
              <div className="flex flex-col text-left">
                <h6 className="font-bold text-sm">
                  {selectedWallet.wallet_description} ({selectedWallet.wallet_number})
                </h6>
                <span className="text-sm">
                  {selectedWallet.wallet_currency} {selectedWallet.wallet_amount}
                </span>
              </div>
            ) : (
              <>{t("SELECT_WALLET")}</>
            )}
            {loadingWallets ? <FontAwesomeIcon icon={faSpinner} className="bg-white-900" /> : <FontAwesomeIcon icon={faChevronDown} className="bg-white-900" />}
          </MenuButton>

          <MenuItems
            transition
            style={{ zIndex: 1000 }}
            className="absolute z-10 mt-2 w-56 origin-top-right divide-y divide-white/10 rounded-md bg-gray-800 outline-1 -outline-offset-1 outline-white/10 transition data-closed:scale-95 data-closed:transform data-closed:opacity-0 data-enter:duration-100 data-enter:ease-out data-leave:duration-75 data-leave:ease-in"
          >
            {availableWallets?.length === 0 && <div className="px-4 py-3 text-sm text-gray-300">{t("NO_WALLET_AVAILABLE")}</div>}

            {availableWallets?.map((wallet) => (
              <div className="py-1 w-full" key={wallet._id}>
                <MenuItem key={wallet._id}>
                  <span className="block px-4 py-2 text-sm text-gray-300 data-focus:bg-white/5 data-focus:text-white data-focus:outline-hidden" onClick={() => setSelectedWallet(wallet)}>
                    {wallet.wallet_description} - {wallet.wallet_currency} {wallet.wallet_amount}
                  </span>
                </MenuItem>
              </div>
            ))}
          </MenuItems>
        </Menu>

        <div className="relative  my-5">
          <OInputField
            name="amount"
            errors={errors}
            inputLabel={
              <>
                {t("CASH_OUT_RECEIVED_AMOUNT")}
                <span className="text-red-500">*</span>
              </>
            }
            type="number"
            register={register("amount", {
              required: t("PLEASE_ENTER_RECEIVED_AMOUNT"),
              onChange: (e) => handleAmount(e),
              validate: (value) => {
                return value !== "0" ? true : t("VALUE_CAN_NOT_BE_LESS_THAN_0.01");
              },
            })}
            onKeyDown={(e) => {
              pressedKeys.push(e.key);
              var lastKey = pressedKeys[pressedKeys.length - 2];
              if (lastKey === ".") {
                if (["-", ".", "+", "e"].includes(e.key)) {
                  e.preventDefault();
                }
              } else if (["-", "+", "e"].includes(e.key)) {
                e.preventDefault();
              }
            }}
          />
        </div>
        <div></div>
        <button
          class="bg-LightBlue hover:bg-DarkBlue cursor-pointer   text-white  font-medium  w-full active:bg-slate-100 text-sm px-8 py-4 rounded-lg shadow hover:shadow-lg outline-none focus:outline-none  ease-linear transition-all duration-150 undefined"
          type="submit"
          onClick={handleSubmit(handleSubmitPreview)}
        >
          {cashInLoading ? "Loading..." : <>{t("O_SUBMIT")}</>}
        </button>
        {cashPreview ? (
          <>
            <div id="add-agent" className="fixed  pt-16 z-40 h-screen px-6 pb-4 overflow-y-auto bg-white sm:w-96 w-80  right-0 top-0 " aria-labelledby="drawer-label">
              <div>
                <button
                  onClick={() => setShowCashOutModal(false)}
                  title="Close"
                  type="button"
                  data-drawer-hide="drawer-example"
                  aria-controls="drawer-example"
                  className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 absolute top-2.5 right-2.5 inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white"
                >
                  <img src="./images/close-circle.png" alt="close" />

                  <span className="sr-only">{t("CLOSE_MENU")}</span>
                </button>
              </div>
              <div className="flex items-center w-full justify-center mb-4">
                <div className="relative text-center ">
                  <h3 className="font-medium text-[18px] mb-4">
                    <div className="my-3 flex flex-col items-center w-full justify-center">
                      <img src={cashPreviewData.image} alt="pfp" />
                      {cashPreviewData.firstName} {cashPreviewData.lastName}
                    </div>
                    {t("O_CUSTOMER_WILL_GET")} {t("O_LEK")} {cashPreviewData.amountToBeReceived} {t("CASH_IN_WALLET_TRANSFER")} {t("O_LEK")} {cashPreviewData.amount}.
                  </h3>
                </div>
              </div>
              <div className="flex justify-between items-center">
                <button
                  class="bg-LightBlue hover:bg-DarkBlue cursor-pointer text-white  font-medium active:bg-slate-100 text-sm px-8 py-4 rounded-lg shadow hover:shadow-lg outline-none focus:outline-none  ease-linear transition-all duration-150 undefined"
                  onClick={() => setShowCashOutModal(false)}
                >
                  {t("CASH_IN_CANCEL")}
                </button>
                <button
                  class="bg-LightBlue hover:bg-DarkBlue cursor-pointer text-white  font-medium active:bg-slate-100 text-sm px-8 py-4 rounded-lg shadow hover:shadow-lg outline-none focus:outline-none  ease-linear transition-all duration-150 undefined"
                  type="submit"
                  onClick={handleSubmit(handleSubmitOtp)}
                >
                  {cashInLoading ? "Loading..." : <>{t("CASH_IN_OK")}</>}
                </button>
                {cashPreviewOtp ? (
                  <div id="add-agent" className="fixed  pt-16 z-40 h-screen px-6 pb-4 overflow-y-auto bg-white sm:w-96 w-80 right-0 top-0 " aria-labelledby="drawer-label">
                    <div>
                      <button
                        onClick={clearTime}
                        title="Close"
                        type="button"
                        data-drawer-hide="drawer-example"
                        aria-controls="drawer-example"
                        className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 absolute top-2.5 right-2.5 inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white"
                      >
                        <img src="./images/close-circle.png" alt="close" />

                        <span className="sr-only">{t("CLOSE_MENU")}</span>
                      </button>
                    </div>
                    <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6  rounded">
                      <div className=" py-5 flex-auto">
                        <section className="w-full">
                          <div className="w-full flex justify-between">
                            <div className="font-semibold">{t("O_VERIFICATION_CODE")}</div>{" "}
                          </div>
                          <div className="font-semibold mt-4 ">{t("O_ENTER_OTP")}</div>
                          <OtpInput
                            inputStyle={{
                              border: "solid 1px #dfdfdf",
                              width: "5rem",
                              height: "2.4rem",
                              marginRight: ".5rem",
                              outline: "none",
                              borderRadius: "8px",
                            }}
                            shouldAutoFocus
                            containerStyle="text-center mt-2"
                            value={otp}
                            onChange={handleOTPChange}
                            isInputNum={true}
                            numInputs={4}
                            separator={<span> </span>}
                          />
                          <ErrorMessage message={otpError} />
                          <OButton label={cashInLoading ? "Loading..." : startCase("Verify")} extraClasses="w-full mt-4" type="button" onClick={handleSubmit(handleSubmitForm)} disabled={!timerActive} />
                          <div className="text-xs mt-5 text-center">
                            {t("O_DID_NOT_RECEIVE_OTP")}{" "}
                            <span
                              className="text-violet-700"
                              onClick={handleSubmit(handleResendOTP)}
                              style={{
                                cursor: "pointer",
                              }}
                            >
                              <span
                                style={{
                                  color: seconds === 0 ? "blue" : "gray",
                                }}
                              >
                                {" "}
                                {t("O_RESEND_OTP")}{" "}
                              </span>
                              ( {t("O_EXPIRING_IN")} {minutes}:{seconds < 10 ? 0 + seconds : seconds})
                            </span>
                          </div>
                        </section>
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </>
        ) : (
          ""
        )}
      </div>

      <div class="bg-gray-900  bg-opacity-50 dark:bg-opacity-80 fixed inset-0 z-30 overlay" />
    </>
  );
};

export default CashOut;
